@if (showLatestOnly) {
  @if (msgService.message$ | async; as currentMessage) {
    <ng-container *ngTemplateOutlet="message; context: { msg: currentMessage }" />
  }
} @else {
  @for (msg of msgService.pushMessages$ | async; track $index) {
    <ng-container *ngTemplateOutlet="message; context: { msg: msg }" />
  }
}

<ng-template #message let-msg="msg">
  @if (msg) {
    <p>
      <ngb-alert [type]="msg.msgType" (close)="msgService.removeMessage(msg)" [innerHTML]="msg | sanitizedMessage" />
    </p>
  }
</ng-template>
